import React, { useState } from "react";
import { BillNoComp, itemListComp, searchItemInput } from "./common";
import SectionBillhelp from "./comp";
import { Chip, Divider } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import { FormatNumber2 } from "../utility/functions/formatNumber";
import { onBillSave } from "./function";
import { useSelector } from "react-redux";
import { selectWidth } from "../utility/Redux/profile";
const MobileStockOrdering = ({
  searchBoxRef,
  searchRef,
  width,
  setRemarksStatus,
  setBarCodeScannerStatus,
  itemSearchText,
  billCartList,
  dispatch,
  setBillCartList,
  billingDetails,
  customerDetails,
  setAlertTwoButtonModal,
  isStockCheck,
  setSearchQnty,
  setItem_Box,
  setSalePriceModalStatus,
  setItemSearchText,
  prefix,
  token,
  setItemList,
  setSectionName,
  profileSetting,
  sectionList,
  sectionName,
  GetListItemMaster,
  currentItemsPage,
  setIsSectionDraweropen,
  setTotalItemsPage,
  totalItemsPage,
  isSectionDrawerOpen,
  itemList,
  itemImgList,
  onChangePagination,
  Undo,
  setBillNo,
  setViewBillStatus,
  naviagte,
  orderType,
  setBillHelpStatus,
  date,
  setSettingModalStatus,
  setOrdertype,
  setListAccountMasterHelp,
  accountdetails,
  setIsRemove0Active,
  isRemove0Active,
  setAccountDetails,
}) => {
  return (
    <div className="p-2 w-full overflow-y-auto h-full ">
      <BillNoComp
        setBillHelpStatus={setBillHelpStatus}
        billCartList={billCartList}
        date={date}
        profileSetting={profileSetting}
        dispatch={dispatch}
        setSettingModalStatus={setSettingModalStatus}
        setOrdertype={setOrdertype}
        orderType={orderType}
        setListAccountMasterHelp={setListAccountMasterHelp}
        accountdetails={accountdetails}
        setIsRemove0Active={setIsRemove0Active}
        isRemove0Active={isRemove0Active}
        setBillCartList={setBillCartList}
        setAlertTwoButtonModal={setAlertTwoButtonModal}
        setAccountDetails={setAccountDetails}
      />
      <div className="w-full mt-1">
        {searchItemInput(
          searchBoxRef,
          searchRef,
          width,
          setBarCodeScannerStatus,
          itemSearchText,
          billCartList,
          dispatch,
          setBillCartList,
          billingDetails,
          customerDetails,
          setAlertTwoButtonModal,
          isStockCheck,
          setSearchQnty,
          setItem_Box,
          setSalePriceModalStatus,
          setItemSearchText,
          prefix,
          token,
          setItemList,
          setSectionName,
          profileSetting,
          true,
          () => {},
          accountdetails,
          orderType
        )}
      </div>
      <div className="mt-2">
        <SectionBillhelp
          horizontal={true}
          setIsSectionDraweropen={setIsSectionDraweropen}
          isSectionDrawerOpen={isSectionDrawerOpen}
          sectionList={sectionList}
          sectionName={sectionName}
          setSectionName={setSectionName}
          GetListItemMaster={GetListItemMaster}
          setItemList={setItemList}
          currentItemsPage={currentItemsPage}
          setTotalItemsPage={setTotalItemsPage}
        />
      </div>
      <div
        style={{
          height: `calc(100% - 100px)`,
        }}
      >
        {itemListComp(
          itemList,
          billCartList,
          setBillCartList,
          billingDetails,
          customerDetails,
          dispatch,
          setAlertTwoButtonModal,
          isStockCheck,
          setItem_Box,
          setSalePriceModalStatus,
          itemImgList,
          prefix,
          token,
          setSectionName,
          setItemList,
          width,
          profileSetting,
          totalItemsPage,
          currentItemsPage,
          onChangePagination,
          true,
          setRemarksStatus,
          orderType
        )}
      </div>
      <div className="h-[80px]"></div>
      <BottomCartModal
        isOpen={billCartList[0]}
        itemCount={""}
        onViewCart={() => {}}
        setBillCartList={setBillCartList}
        billCartList={billCartList}
        onSave={() => {
          onBillSave(
            billCartList,
            dispatch,
            prefix,
            token,
            Undo,
            "",
            setBillNo,
            setAlertTwoButtonModal,
            setViewBillStatus,
            "",
            "",
            "",
            "",
            "",
            "",
            false,
            customerDetails,
            () => {},
            "",
            "",
            naviagte,
            () => {},
            () => {}
          );
        }}
      />
    </div>
  );
};

export default MobileStockOrdering;
const BottomCartModal = ({
  isOpen,
  itemCount,
  billCartList,
  onSave,
  onClose,
  setBillCartList,
}) => {
  const [expanded, setExpanded] = useState(false);

  const handleViewCart = () => {
    setExpanded(true);
  };

  const handleClose = () => {
    setExpanded(false);
    onClose?.();
  };
  const width = useSelector(selectWidth);
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ y: "100%" }}
          animate={{ y: 0 }}
          exit={{ y: "100%" }}
          transition={{ type: "spring", stiffness: 300, damping: 25 }}
          className={`fixed bottom-0 ${
            width > 450 ? "left-10" : "left-0"
          }  border-t right-0 z-50 bg-white px-3 pt-3 pb-4 border-gray-500  shadow-md rounded-t-2xl md:hidden`}
        >
          {!expanded ? (
            <>
              <div className="pb-2 pl-1 text-gray-700">
                View your added items
              </div>
              <div className="flex justify-between items-center bg-orange py-2 px-3 rounded-md">
                <div className="text-lg font-semibold text-black">
                  {itemCount} Item{itemCount > 1 ? "s" : ""} Added
                </div>
                <button
                  onClick={handleViewCart}
                  className="text-orange-700 font-medium "
                >
                  View Cart
                </button>
              </div>
            </>
          ) : (
            <div className="flex flex-col gap-2">
              <div className="font-semibold text-brown mb-2">
                Your Bill Cart
              </div>
              <div className="max-h-[400px] overflow-y-auto space-y-2 pr-2">
                {billCartList
                  .filter((b) => b.QNTY > 0)
                  .map((item, index) => (
                    <div
                      key={index}
                      className="flex justify-between items-center border p-2 rounded"
                    >
                      <div>
                        <div className="font-medium text-sm">
                          {item.ITEMNAME}
                        </div>
                        <div className="text-xs text-gray-500">
                          Qty: {item.QNTY} | Net Rate: ₹
                          {FormatNumber2(item.PUR_PRICE)}
                        </div>
                      </div>
                      <div className="flex">
                        <div className="font-semibold text-right text-sm">
                          ₹{FormatNumber2(item.AMOUNT)}
                        </div>
                        <button
                          onClick={() => {
                            setBillCartList((b) =>
                              b.filter((i) => i.ICODE !== item.ICODE)
                            );
                          }}
                          className="ml-1"
                        >
                          <i className="bi bi-x-lg text-red-500 " />
                        </button>
                      </div>
                    </div>
                  ))}
              </div>
              <div className="flex justify-end gap-2 pt-3">
                <button
                  onClick={handleClose}
                  className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md text-sm"
                >
                  Close
                </button>
                <button
                  onClick={() => {
                    onSave();
                    handleClose();
                  }}
                  className="px-4 py-2 bg-green text-black rounded-md text-sm"
                >
                  Save
                </button>
              </div>
            </div>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
